module.exports = [{"id":0,"title":"Project 0","solution":22,"exception":1,"addresses":1},{"id":1,"title":"Project 1","solution":30,"exception":100,"addresses":12},{"id":2,"title":"Project 2","solution":23,"exception":73,"addresses":77},{"id":3,"title":"Project 3","solution":73,"exception":55,"addresses":4},{"id":4,"title":"Project 4","solution":44,"exception":8,"addresses":135},{"id":5,"title":"Project 5","solution":92,"exception":99,"addresses":8}]


//////////////////
// WEBPACK FOOTER
// ./src/view/screens/ProjectsList/dummy.json
// module id = 1321
// module chunks = 0